import Layout2 from '@/layout/Layout2'
import LayoutBlank from '@/layout/LayoutBlank'

export default [{
  path: '/home',
  component: LayoutBlank,
  children: [{
    path: '',
    component: () => import('@/merchanAdmin/home/shopList'),
    
  }]
}]
